import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import DespesasEduc from '../../../components/educacao/despesas';


function DespesasEducScreen() {
    return (
        <Fragment>
            <Head titulo="Despesas da Secretaria de Educação em Macuco" />
            <Header />
            <Container>
               <DespesasEduc /><br/><br/>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default DespesasEducScreen;